




























































































import { Component, Prop, Watch } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import ManualFeesCreateDialog from '@/components/Products/ProductFees/Manual/ManualFeesCreateDialog.vue';
import ManualFeesEditDialog from '@/components/Products/ProductFees/Manual/ManualFeesEditDialog.vue';
import ManualFeesDeleteDialog from '@/components/Products/ProductFees/Manual/ManualFeesDeleteDialog.vue';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';
import { ProductIssueDetailsModule } from '@/store/Products/ProductIssueDetailsModule';
import EntityType from '@/models/Shared/EntityType';
import ManualFee from '@/models/Products/ProductFees/ManualFee';

@Component({ name: 'ManualFees', components: { ManualFeesCreateDialog, ManualFeesEditDialog, ManualFeesDeleteDialog } })
export default class extends SaascadaVue {

    EntityType = EntityType;
    headers = [
        { text: this.$t('pageText.products.fields.name'), width: "100%" }
    ];
    manualFeesPage = 1;

    @Watch('manualFeesPage')
    async onManualFeesPageChanged() {
        // Preselect the first row on the next page
        // NOTE: This is only needed when paginating locally through results
        const nextItemIndex = (this.manualFeesPage - 1) * this.pageSize;
        const nextItem = this.manualFees[nextItemIndex];
        await ProductDetailsModule.updateCurrentManualFee(nextItem);
    }

    async updateCurrentManualFee(manualFee: ManualFee) {
        await ProductDetailsModule.updateCurrentManualFee(manualFee);
    }

    @Prop({required: true})
    entityType: EntityType;

    get currentManualFee() {
        if (this.entityType === EntityType.Product) {
            return ProductDetailsModule.currentManualFee;
        }
        return ProductIssueDetailsModule.currentManualFee;
    }

    get manualFees() {
        if (this.entityType === EntityType.Product) {
            return ProductDetailsModule.product.generalFeeSettings.manualFees;
        }
        return ProductIssueDetailsModule.productIssue.generalFeeSettings.manualFees;
    }

    get totalManualFeesPages() {
        if (this.entityType === EntityType.Product) {
            return ProductDetailsModule.totalManualFeesPages;
        }
        return ProductIssueDetailsModule.totalManualFeesPages;
    }

    get loading() {
        if (this.entityType === EntityType.Product) {
            return ProductDetailsModule.loading;
        }
        return ProductIssueDetailsModule.loading;
    }

    get pageSize() {
        if (this.entityType === EntityType.Product) {
            return ProductDetailsModule.pageSize;
        }
        return ProductIssueDetailsModule.pageSize;
    }

}
